/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

/**
 * Which view a projected workflow story was built for.
 */
export enum EnumWorkflowStoryMode {
    /**
     * Projected from the definition's YAML alone; nothing has run.
     */
    Preview = 0,
    /**
     * A run in progress.
     */
    Live = 1,
    /**
     * A finished run.
     */
    History = 2,
}
